import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import settings from './modules/settings'
// import websocket from './module/websocket'
import permission from './modules/permission'
import getters from './getters'
import tagsView from './modules/tagsView'
import machine from './modules/dataAnalysis'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    // websocket,
    user,
    permission,
    app,
    settings,
    tagsView,
    machine
  },
  getters,
})
export default store